import { providerLoginApi } from '@ax/service';
import { ProviderLoginInput } from '@ax/service/src/auth-interface';
import { useMutation } from '@tanstack/react-query';

export function useProviderLogin() {
  return useMutation({
    mutationKey: ['provider-login'],
    mutationFn: (loginDataInput: ProviderLoginInput) => providerLoginApi(loginDataInput),
  });
}
